import { SalesOrderStatus } from '../constants/sales-order-status.js';
import { TERMINAL_SALES_ORDER_STATUS_IDS } from '../constants/sales-order-terminal-statuses.js';
import { BLOCKED_ITEM_EDIT_STATUSES } from '../sales-order-lines/blocked-item-edit-statuses.js';
const CANCELLED_OR_REJECTED = [
    SalesOrderStatus.CANCELLED,
    SalesOrderStatus.REJECTED,
];
const COMPLETE_OR_LATER = TERMINAL_SALES_ORDER_STATUS_IDS;
// Derived so a status added to the item-edit lock locks the shipped-or-later header fields too.
const SHIPPED_OR_LATER = BLOCKED_ITEM_EDIT_STATUSES;
// Addresses and the warehouse stay editable through Delivery Scheduling.
const READY_TO_DELIVER_OR_LATER = [
    SalesOrderStatus.READY_TO_DELIVER,
    ...SHIPPED_OR_LATER,
];
const NOT_EDITABLE_STATUSES = {
    // WHY: a terms change after delivery would re-price an invoiced order; the only post-ship path is Correct order.
    paymentTerms: SHIPPED_OR_LATER,
    customerPurchaseOrder: COMPLETE_OR_LATER,
    note: CANCELLED_OR_REJECTED,
    internalNotes: CANCELLED_OR_REJECTED,
    deliveryPreferences: SHIPPED_OR_LATER,
    carrierService: SHIPPED_OR_LATER,
    // WHY (spec §8): ship terms lock with the other delivery fields once the order ships.
    shipTerms: SHIPPED_OR_LATER,
    // WHY: FOB point records where title/risk transferred, a fact fixed once the order ships.
    fobPoint: SHIPPED_OR_LATER,
    priority: SHIPPED_OR_LATER,
    salesperson: COMPLETE_OR_LATER,
    billToShipToAddress: READY_TO_DELIVER_OR_LATER,
    scheduledDates: SHIPPED_OR_LATER,
    // The status half only, since updateSalesOrder also refuses once a pick item is committed or short.
    fulfillmentLocationGroup: READY_TO_DELIVER_OR_LATER,
    campaignAttribution: COMPLETE_OR_LATER,
    manifestNumber: SHIPPED_OR_LATER,
    customerContact: COMPLETE_OR_LATER,
    adjustmentLines: BLOCKED_ITEM_EDIT_STATUSES,
};
/** The server-side field-editability gate for `updateSalesOrder`. */
export function isSalesOrderFieldEditable(field, statusId) {
    return !NOT_EDITABLE_STATUSES[field].includes(statusId);
}
//# sourceMappingURL=updatable-fields-by-status.js.map